
import { mapState, mapGetters } from "vuex";
import PairPlatforms from "~/assets/images/pairPlatforms.svg";
import WaitingForNewOrders from "~/assets/images/waitingForNewOrders.svg";
import PairNowDialogMobile from "../dialogs/info-dialog-mobile.vue";
import integrationUnderProcessing from "../reciever/integration-under-processing.vue";
import WelcomeUserScreen from "../common/welcome-user-screen.vue";
import OrderListRow from "./order-list-row.vue";

export default {
  data() {
    return {
      PairPlatforms,
      WaitingForNewOrders,
      showPairNowSheet: false,
      isIntegrationUnderProcessing: false,
      isWaitingForNewOrders: false,
      sections: []
    };
  },
  props: {
    hasChannelsPaired: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PairNowDialogMobile,
    integrationUnderProcessing,
    WelcomeUserScreen,
    OrderListRow
  },

  computed: {
    ...mapState("reciever", ["orders"]),
    ...mapGetters("reciever", [
      "getSelectedChannelAllOrders",
      "getSelectedChannelNewOrders",
      "getSelectedChannelPreparingOrders",
      "getSelectedChannelReadyForDeliveryOrders",
      "getSelectedChannelPickedUpOrders"
    ])
  },
  mounted() {
    this.sections = this.$constants.OrderStatuses.SECTIONS;
    if (!this.hasChannelsPaired) {
      setTimeout(() => {
        this.showPairNowSheet = true;
      }, 8000);
    }
  },
  methods: {
    getList(status) {
      if (status === "newOrders") {
        return this.getSelectedChannelNewOrders;
      } else if (status === "preparing") {
        return this.getSelectedChannelPreparingOrders;
      } else if (status === "readyForDelivery") {
        return this.getSelectedChannelReadyForDeliveryOrders;
      } else if (status === "pickedUp") {
        return this.getSelectedChannelPickedUpOrders;
      } else {
        return [];
      }
    },
    numberOfEmptyColumns(section) {
      let noOfCols = 3;
      let colsWithDataCount = this.getList(section.status).length % noOfCols;
      if (!!colsWithDataCount) {
        return noOfCols - (this.getList(section.status).length % noOfCols);
      }
    }
  }
};
